import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NewsletterCategoryForm from '../../../components/forms/NewsletterCategoryForm';
import { useNewsletterCategoryApi } from '../../../hooks/useNewsletterCategoryApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { NewsletterCategoryDTO } from '../../../services/apiClient';

const NewsletterCategoryEdit: React.FC = () => {
  const { getById, edit, isLoading } = useNewsletterCategoryApi();
  const [entityData, setEntityData] = useState<NewsletterCategoryDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Newsletter Categories', href: '/admin/newslettercategories' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching NewsletterCategory data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/newslettercategories');
    } catch (error) {
      console.error('Error updating NewsletterCategory:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/newslettercategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.NewsletterCategory.Edit'
    >
        {entityData ? (
          <NewsletterCategoryForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/newslettercategories')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default NewsletterCategoryEdit;